import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Button,
  Modal,
  Box,
  Stack,
  TablePagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import GetAppIcon from "@mui/icons-material/GetApp";
import * as XLSX from "xlsx";
import DateFormatter from "./DateFormatter";
import ExportToExcelBTN from "./ExportToExcelBTN";

function ImageTable3({ data }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [rotation, setRotation] = useState(0);
  const filteredData = data;
  //   const filteredData = data.filter(
  //     (row) =>
  //       row.UnitCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       row.UnitCode.toLowerCase().includes(searchTerm.toLowerCase())
  //   );

  const handleOpen = (imgLink) => {
    setModalImage(`https://www.apsgroupapp.com/uploads/${imgLink}`);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setRotation(0);
  };

  const rotateLeft = () => setRotation((prev) => prev - 90);
  const rotateRight = () => setRotation((prev) => prev + 90);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    XLSX.writeFile(wb, "exportedData.xlsx");
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <Stack
        sx={{
          display: "flex",
          alignItems: "flex-end",
          flexDirection: "row",
          justifyContent: "space-between",
          margin: 2,
        }}
      >
        <ExportToExcelBTN data={data} />
      </Stack>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                S.No
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Unit Code
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Emp Code
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Report Name
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Sub-Report Name
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Remarks
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Time
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Status/View
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow hover key={index}>
                  <TableCell sx={{ padding: "10px" }}>
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell sx={{ padding: "0px" }}>{row.Unitcode}</TableCell>
                  <TableCell sx={{ padding: "0px" }}>{row.EmpCode}</TableCell>
                  <TableCell sx={{ padding: "0px" }}>
                    {row.ReportName}
                  </TableCell>
                  <TableCell sx={{ padding: "0px" }}>
                    {row.SubReportName}
                  </TableCell>
                  <TableCell sx={{ padding: "0px" }}>{row.Remark}</TableCell>
                  <TableCell sx={{ padding: "0px" }}>
                    <DateFormatter date={row.Time} />
                  </TableCell>
                  <TableCell sx={{ padding: "0px" }}>
                    {row.ImgName == "NULL" ? (
                      "NOT DONE"
                    ) : (
                      <IconButton onClick={() => handleOpen(row.ImgName)}>
                        <VisibilityIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img
            src={modalImage}
            alt="Modal Display"
            style={{ maxWidth: "100%", transform: `rotate(${rotation}deg)` }}
          />
          <Stack sx={{ display: "flex", flexDirection: "row" }}>
            <IconButton onClick={rotateLeft}>
              <RotateLeftIcon />
            </IconButton>
            <IconButton onClick={rotateRight}>
              <RotateRightIcon />
            </IconButton>
          </Stack>
        </Box>
      </Modal>
    </Paper>
  );
}

export default ImageTable3;
